import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { ElectionColleges } from 'src/app/pap-creation/pap-dto/pap-dto';

@Component({
  selector: 'app-pap-college-verification',
  templateUrl: 'pap-college-verification.component.html',
  styleUrls: ['./pap-college-verification.component.less', '../../../shared/common.less'],
})

export class PapCollegeVerificationComponent implements OnInit {
  @Input() colleges: ElectionColleges[] = [];
  @Input() isExpanded: boolean = false;
  @Input() numberOfColleges: number;
  @Output() collegesChange = new EventEmitter<ElectionColleges[]>();
  @Output() validated = new EventEmitter<boolean>();
  @Output() editRequested = new EventEmitter<void>();

  needPap: boolean = undefined;
  minDate: string;
  isValidated: boolean = false;

  constructor(
  ) {
    const today = new Date();
    this.minDate = today.toISOString().substring(0, 10);
  }
  
  toggleExpand() {
    this.isExpanded = !this.isExpanded;
  }

  onValidate() {
    this.isExpanded = false;
    this.isValidated = true;
    this.validated.emit(true);
  }

  onEdit() {
    this.editRequested.emit();
  }
  
  onCollegeChange() {
    this.collegesChange.emit(this.colleges);
  }

  ngOnChanges(): void {
    
  }
  
  ngOnInit(): void {
  }
}
